import { errorMessageFrom } from "../../../../../../utils/formErrors";
import React,{useState, useEffect, useMemo} from 'react';
import GeofenceField from './new/GeofenceField';
import { Box, CircularProgress, Autocomplete, TextField} from "@mui/material";
import styled from '@emotion/styled';
import BtnSecondary from "../../../../.../../../../component/SecondaryButton";
import { getOrgDepartments, getOrgEmployees, getOrgGroups, getOrgShifts, getLegalUnitList } from "../../../../.../../../../services/globalData";
import { useLocation } from "react-router-dom";
import {getAttendancePolicyById, updateAttendancePolicy } from '../../../../.../../../../services/attendancePolicy';
import { useNotify } from '../../../../.../../../../component/NotificationProvider';
import { tokens, radius } from '../../../../../../theme';
import { findGroup } from '../../../../.../../../../utils/findGroup';
import { findDepartment } from '../../../../.../../../../utils/findDepartment';
import FormField from '../../../../.../../../../component/Formfield';
import { currentUserDetails } from '../../../../.../../../../utils/currentUserDetails';
import DateField from '../../../../.../../../../component/DateField';
import BtnPrimary from '../../../../.../../../../component/PrimaryButton';
import TypeBtn from '../../../../.../../../../component/AddRemoveButton';
import SortByTable from '../../../../.../../../../component/assign-policy/SortByTable';
// import AttendancePolicyEditCategory from './AttendancePolicyEditCategory';
import ErrorMsg from '../../../../.../../../../component/ErrorMsg';
import { policyPayload } from './policyPayload';
import SaveDialog from '../../../../.../../../../component/SaveDialog';
import { SettingsSaveBar } from '../../../../../../component/settings';
import TopBar from '../../../../../../component/TopBar';
import MainBox from '../../../../container/MainBox';
import CheckboxField from '../../../../../../component/CheckboxField';
import SwitchToggle from '../../../../../../component/SwitchToggle';
import RadioButtonGroup from '../../../../../../component/RadioButtonGroup';
import MultiSectionClock from '../../../../../../component/MultiSectionClock';


const HeadingBox = styled(Box)({
        fontSize: "1rem",
        lineHeight: 1.7,
});

const TextBox = styled(HeadingBox)({
  color: tokens.textMuted,
});

const HeaderSection = () => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1.5rem', alignItems: 'center' }}>
      <Box sx={{ fontSize: '1.25rem', fontWeight: 600, color: tokens.text }}>
          Attendance Policy
      </Box>
      <BtnSecondary
         sx={{ height: '2.75rem', px: '1.25rem', borderRadius: '10px' }}
         to={"/app/attendance-policy/listing"}
      >
          Back
      </BtnSecondary>
  </Box>
);

// Clean section header — the whole form is editable inline (no per-section edit lock),
// so this is just a titled divider matching the create wizard.
const Headings = ({title, description}) => (
    <Box sx={{ width: "100%", marginBottom: "1.25rem", paddingBottom: "0.75rem", borderBottom: `1px solid ${tokens.border}` }}>
      <Box sx={{ fontSize: "1rem", fontWeight: 600, color: tokens.text }}>{title}</Box>
      {description && <Box sx={{ fontSize: "0.8125rem", color: tokens.textMuted, marginTop: "0.25rem" }}>{description}</Box>}
    </Box>
)


const AttendancePolicyEdit = ({type}) => {
        const {state} = useLocation();
        const createdBy = currentUserDetails().fname+" "+currentUserDetails().lname;
        const [loading, setLoading] = useState(true);
        const [apiCall,setApiCall]=useState(false);
        const [isSaveOpen, setIsSaveOpen]=useState(false);
        const [policyData,setPolicyData] = useState({});
        /**
         * What the policy looked like when it loaded.
         *
         * The Save button here was always on screen, which told nobody whether
         * they had actually changed anything — on a form this long that is the
         * difference between "I edited the grace period" and "I pressed Save on
         * a policy I was only reading". Assignment is tracked alongside the
         * policy body because it is saved by a separate call.
         */
        const [baseline, setBaseline] = useState(null);
        const [startDateDialogOpen, setStartDateDialogOpen] = useState(false);
        const [endDateDialogOpen, setEndDateDialogOpen] = useState(false);
        const [validationErrors, setValidationErrors] = useState({
                                                                  code:"",
                                                                  name:"",
                                                                  startDate:"",
                                                                  endDate:"",
                                                                });
        const [error,setError]=useState("");
        const notify = useNotify();
        const approverOptions = (getOrgEmployees() || []).map(employee => ({
                    name: employee.fname+" "+employee.lname,
                    value: employee._id
        }));
        const [sortBy,setSortBy] = useState("");
        // The form is fully editable inline with a single Save (modern pattern) —
        // these stay true so existing `disabled={!…Edit}` call sites still read.
        const detailsEdit = true, categoryEdit = true, assignPolicyEdit = true, approverEdit = true;
        const [selectedList,setSelectedList] = useState({department: [],employeeGroup:[]});
        const [data, setData] = useState();
        const allDepartments = getOrgDepartments();
        const allGroups = getOrgGroups();
        const shiftOptions = getOrgShifts()?.map((shift) => ({
          value: shift?._id,
          name: shift?.name,
        }));
        const [selectedShifts, setSelectedShifts] = useState([]);
        const entityOptions = (getLegalUnitList() || []).map((unit) => ({ value: unit._id, name: unit.name }));
      
        const handleShiftChange = (event, newValue) =>{
          setSelectedShifts(newValue);
          const selectedIds = newValue.map((shift) => shift?.value);
          handleChange('shifts',selectedIds);
        }

        useEffect(()=>{
          setData(sortBy==="Departments"?allDepartments:allGroups);
        },[sortBy])

        useEffect(()=>{
                getPolicyData(state.policyId);
        },[]);

        //to get policy data
        const getPolicyData = async (policyId) => {
                setLoading(true);
                try {
                    const res = await getAttendancePolicyById(policyId);
                    const data = res.data;
                    if(res.success){
                          setPolicyData(prevState => ({
                            ...prevState,
                            code: data?.code,
                            name: data?.name,
                            startDate: data?.startDate?.split('T')[0],
                            endDate: data?.endDate?.split('T')[0],
                            enableGeofencing: data?.enableGeofencing,
                            allowMobileClockIn: data?.allowMobileClockIn,
                            requireCommentMobileClockIn: data?.requireCommentMobileClockIn,
                            allowWebClockIn: data?.allowWebClockIn,
                            requireCommentWebClockIn: data?.requireCommentWebClockIn,
                            enableAbsenteeism: data?.enableAbsenteeism,
                            autoDetectAbsenteeism: data?.autoDetectAbsenteeism,
                            minDailyHours: data?.minDailyHours,
                            absenteeismThreshold: data?.absenteeismThreshold,
                            absenteeismTimePeriod: data?.absenteeismTimePeriod,
                            penaliseAdjoiningHolidays: data?.penaliseAdjoiningHolidays,
                            penaliseAdjoiningWeekends: data?.penaliseAdjoiningWeekends,
                            minAbsenceDurationForAdjoiningHolidayPenalty: data?.minAbsenceDurationForAdjoiningHolidayPenalty,
                            minAbsenceDurationForAdjoiningWeekendPenalty: data?.minAbsenceDurationForAdjoiningWeekendPenalty,
                            absenteeismPenalty: data?.absenteeismPenalty,
                            noOfPaidLeaveDeductForAbsenteeism: data?.noOfPaidLeaveDeductForAbsenteeism,
                            noOfDaysOfPayLossForAbsenteeism: data?.noOfDaysOfPayLossForAbsenteeism,
                            enableTardiness: data?.enableTardiness,
                            tardinessType:data?.tardinessType,
                            tardinessThreshold:data?.tardinessThreshold,
                            minimumPunctuality:data?.minimumPunctuality,
                            tardinessTimePeriod:data?.tardinessTimePeriod,
                            punctualityTimePeriod:data?.punctualityTimePeriod,
                            noOfPermissibleLateArrivals:data?.noOfPermissibleLateArrivals,
                            tardinessPenalty:data?.tardinessPenalty,
                            noOfDaysOfPayLossForTardiness: data?.noOfDaysOfPayLossForTardiness,
                            noOfPaidLeaveDeductForTardiness: data?.noOfPaidLeaveDeductForTardiness,
                            gracePeriodMinutes: data?.gracePeriodMinutes ?? 0,
                            punchRoundingMinutes: data?.punchRoundingMinutes ?? 0,
                            roundingDirection: data?.roundingDirection || "nearest",
                            regularization: data?.regularization || { maxPerMonth: 0, windowDays: 0, requiresApproval: true },
                            missedCheckoutPolicy: data?.missedCheckoutPolicy || "flag",
                            isDefault: Boolean(data?.isDefault),
                            legalUnits: (data?.legalUnits || []).map(String),
                            employeeGroup: data?.employeeGroup,
                            department: data?.department,
                            approverIds: data?.approverIds,
                        }));
                        const shiftsInPolicy = shiftOptions?.filter((option) =>
                          data?.shifts?.includes(option.value)
                        );
                        setSelectedShifts(shiftsInPolicy);
                    }
                    if(data?.employeeGroup?.length>0){
                       setSortBy("Groups");
                       setSelectedList(prevState => ({...prevState,employeeGroup: data?.employeeGroup}));
                    }else if(data?.department?.length>0){
                      setSortBy("Departments");
                      setSelectedList(prevState => ({...prevState,department: data?.department}));
                    }
                } catch (error) {
                    notify.error(error?.message || "Failed to load policy data");
                } finally {
                    setLoading(false);
                }
        };
          
        useEffect(() => {
          if (loading || baseline || !Object.keys(policyData).length) return;
          setBaseline(JSON.parse(JSON.stringify({ policyData, selectedList })));
        }, [loading, policyData, selectedList, baseline]);

        const dirtyCount = useMemo(() => {
          if (!baseline) return 0;
          const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);
          let n = Object.keys(policyData)
            .filter((k) => !same(policyData[k], baseline.policyData[k])).length;
          if (!same(selectedList, baseline.selectedList)) n += 1;
          return n;
        }, [policyData, selectedList, baseline]);

        const discardChanges = () => {
          if (!baseline) return;
          setPolicyData(JSON.parse(JSON.stringify(baseline.policyData)));
          setSelectedList(JSON.parse(JSON.stringify(baseline.selectedList)));
        };

        //to manage input
        const handleChange = (field, value) => {
                const updatedValue = field === "code" ? value?.toUpperCase() : value;
                setPolicyData(prevState => ({...prevState, [field]: updatedValue}));
                setValidationErrors(prevState => ({...prevState, [field]: ""}));
                setError("");
        };

        //to display selected policy bearer
        const formatPolicyBearer = (linkTo) =>{
          const employeeGroups = linkTo?.employeeGroup?.map(findGroup)?.map(obj => obj?.name).filter(Boolean).join(', ') || '';
          const departments = linkTo?.department?.map(findDepartment)?.map(obj => obj?.name).filter(Boolean).join(', ') || '';
          if(employeeGroups || departments)
              return `${employeeGroups}${employeeGroups && departments ? ', ' : ''}${departments}`;
          else
              return "No Policy Bearer Assigned Yet"
        }

        const handleAddApproval = () =>{
                setPolicyData(prevState => ({
                        ...prevState,
                        approverIds: [...prevState.approverIds, ""]
                }));
        }
            
        const handleRemoveApprover = (index) => {
                setPolicyData(prevState => {
                    const approverList = [...prevState.approverIds];
                    approverList.splice(index, 1);
                    return {
                        ...prevState,
                        approverIds: approverList
                    };
                });
        };
        
        const handleApproverChange = (index, value) => {
                setPolicyData(prevState => {
                    const updatedApprover = [...prevState.approverIds];
                    updatedApprover[index] = value;
                    return {
                        ...prevState,
                        approverIds: updatedApprover
                    };
                });
        };
            
      /**
       * One request, one outcome.
       *
       * This used to fire the policy update and the assignment update as two
       * calls, and open the "saved successfully" dialog the moment Save was
       * pressed — before either had answered. A refused save therefore showed
       * "Validation Failed" and "Success!!" together, and the admin had no way
       * to know which to believe. The dialog now opens only on success, and a
       * refusal names the field.
       */
      const handleSaveChanges = async() =>{
        setError("");
        setApiCall(true);
        try {
          const res = await updateAttendancePolicy(state.policyId, policyPayload(policyData, selectedList));
          if (!res?.success) {
            const why = errorMessageFrom(res, "Policy update failed");
            setError(why);
            notify.error(why);
            return;
          }
          setBaseline(JSON.parse(JSON.stringify({ policyData, selectedList })));
          setIsSaveOpen(true);
        } catch (error) {
          notify.error(error?.message || "Something went wrong updating the policy");
        } finally {
          setApiCall(false);
        }
      }

  return (
    loading?(
      <Box sx={{width:"100%",display:"flex", justifyContent:"center", alignItems:"center", height:"100vh"}}>
        <CircularProgress/>
      </Box>
    ):(
    <Box sx={{width:"100%",paddingBlock: "1rem"}}>
      <TopBar MainHeading={"Attendance Policy"}/>
      <MainBox sx={{ padding: "2rem 1.25rem", height:"100%" }}>
        <HeaderSection type={type}/>
        <Box sx={{ background: tokens.card, border: `1px solid ${tokens.border}`, borderRadius: `${radius.card}px`, padding: "1.5rem", marginBottom: "1.5rem" }}>
            <Headings title="Policy Details" description="Name, validity period, and how employees clock in." />
            <Box sx={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
                      <FormField
                          label="Policy Code"
                          type="text"
                          value={policyData.code}
                          validation={validationErrors.code}
                          disabled={!detailsEdit}
                          onChange={(e) => handleChange('code', e.target.value)}
                      />
                      <FormField
                          label="Policy Name"
                          type="text"
                          value={policyData.name}
                          validation={validationErrors.name}
                          disabled={!detailsEdit}
                          onChange={(e) => handleChange('name', e.target.value)}
                      />
                      <DateField
                        label="Policy Valid From"
                        value={policyData.startDate}
                        isDialogOpen={startDateDialogOpen}
                        validation={validationErrors.startDate}
                        openDialog={() => setStartDateDialogOpen(true)}
                        closeDialog={() => setStartDateDialogOpen(false)}
                        onSelect={(date) => {
                                  handleChange('startDate', date)
                                  setStartDateDialogOpen(false)
                                  }}
                        disabled={!detailsEdit}
                      />
                      <DateField
                        label="Policy Valid Till"
                        value={policyData.endDate}
                        isDialogOpen={endDateDialogOpen}
                        validation={validationErrors.endDate}
                        openDialog={() => setEndDateDialogOpen(true)}
                        closeDialog={() => setEndDateDialogOpen(false)}
                        onSelect={(date) => {
                                  handleChange('endDate', date)
                                  setEndDateDialogOpen(false)
                                }}
                        disabled={!detailsEdit}
                      />
                      <Box sx={{width:"100%", display:"flex", justifyContent:"space-between"}}>
                          <Box sx={{width:"48%"}}>
                            <SwitchToggle 
                                  checked={policyData?.allowMobileClockIn} 
                                  onChange={(e)=>handleChange('allowMobileClockIn',e.target.checked)} 
                                  label="Mobile clock in"
                                  disabled={!detailsEdit}
                              />
                              <CheckboxField
                                  label="Enable Geo-fencing"
                                  checked={policyData.enableGeofencing}
                                  disabled={!policyData?.allowMobileClockIn}
                                  onChange={(isChecked) => handleChange('enableGeofencing',isChecked)}
                                  labelStyle={{fontSize: "1rem", lineHeight: 1.7, color: `${!policyData?.allowMobileClockIn?`${tokens.textMuted}80`:tokens.textMuted}`}}
                              />
                              {policyData.enableGeofencing && policyData.allowMobileClockIn && <GeofenceField />}
                              <CheckboxField
                                  label="Comment is mandatory at clock in"
                                  checked={policyData.requireCommentMobileClockIn}
                                  disabled={!policyData?.allowMobileClockIn}
                                  onChange={(isChecked) => handleChange('requireCommentMobileClockIn',isChecked)}
                                  labelStyle={{fontSize: "1rem", lineHeight: 1.7, color: `${!policyData?.allowMobileClockIn?`${tokens.textMuted}80`:tokens.textMuted}`}}
                              />
                              <Box sx={{display:"flex", gap: "1rem", alignItems:"center", marginTop: "1rem"}}>
                                  <TextBox>Grace period before a punch counts as late (minutes)</TextBox>
                                  <FormField width="5rem" type="text" height="3rem" disabled={!detailsEdit}
                                      value={policyData.gracePeriodMinutes ?? 0}
                                      onChange={(e) => handleChange('gracePeriodMinutes', e.target.value === "" ? "" : Number(e.target.value))} />
                              </Box>
                              <Box sx={{display:"flex", gap: "1rem", alignItems:"center", marginTop: "0.75rem"}}>
                                  <TextBox>Punch rounding</TextBox>
                                  <FormField width="11rem" type="select" disabled={!detailsEdit}
                                      options={[{name:"No rounding",value:0},{name:"Nearest 5 min",value:5},{name:"Nearest 10 min",value:10},{name:"Nearest 15 min",value:15}]}
                                      value={policyData.punchRoundingMinutes ?? 0}
                                      onChange={(e) => handleChange('punchRoundingMinutes', Number(e.target.value))} />
                                  {Number(policyData.punchRoundingMinutes) > 0 && (
                                      <FormField width="9rem" type="select" disabled={!detailsEdit}
                                          options={[{name:"Nearest",value:"nearest"},{name:"Round up",value:"up"},{name:"Round down",value:"down"}]}
                                          value={policyData.roundingDirection || "nearest"}
                                          onChange={(e) => handleChange('roundingDirection', e.target.value)} />
                                  )}
                              </Box>
                              <CheckboxField
                                  label="Require approval for regularization (off = auto-apply)"
                                  checked={policyData.regularization?.requiresApproval !== false}
                                  disabled={!detailsEdit}
                                  onChange={(isChecked) => handleChange('regularization', { ...policyData.regularization, requiresApproval: isChecked })}
                                  labelStyle={{fontSize: "1rem", lineHeight: 1.7, color: tokens.textMuted}}
                              />
                              <Box sx={{display:"flex", gap: "1rem", alignItems:"center", marginTop: "0.75rem"}}>
                                  <TextBox>Max regularizations per month (0 = unlimited)</TextBox>
                                  <FormField width="5rem" type="text" height="3rem" disabled={!detailsEdit}
                                      value={policyData.regularization?.maxPerMonth ?? 0}
                                      onChange={(e) => handleChange('regularization', { ...policyData.regularization, maxPerMonth: e.target.value === "" ? 0 : Number(e.target.value) })} />
                              </Box>
                              <Box sx={{display:"flex", gap: "1rem", alignItems:"center", marginTop: "0.75rem"}}>
                                  <TextBox>Regularization window — days back (0 = no limit)</TextBox>
                                  <FormField width="5rem" type="text" height="3rem" disabled={!detailsEdit}
                                      value={policyData.regularization?.windowDays ?? 0}
                                      onChange={(e) => handleChange('regularization', { ...policyData.regularization, windowDays: e.target.value === "" ? 0 : Number(e.target.value) })} />
                              </Box>
                              <Box sx={{display:"flex", gap: "1rem", alignItems:"center", marginTop: "0.75rem"}}>
                                  <TextBox>Missing check-out handling</TextBox>
                                  <FormField width="14rem" type="select" disabled={!detailsEdit}
                                      options={[{name:"Flag for review",value:"flag"},{name:"Auto-close at shift end",value:"autoCloseAtShiftEnd"},{name:"Ignore",value:"none"}]}
                                      value={policyData.missedCheckoutPolicy || "flag"}
                                      onChange={(e) => handleChange('missedCheckoutPolicy', e.target.value)} />
                              </Box>
                          </Box>
                          <Box sx={{width:"48%"}}>
                            <SwitchToggle 
                                  checked={policyData?.allowWebClockIn} 
                                  onChange={(e)=>handleChange("allowWebClockIn",e.target.checked)} 
                                  label="Web clock in"
                                  disabled={!detailsEdit}
                              />
                              <CheckboxField
                                  label="Comment is mandatory at clock in"
                                  checked={policyData.requireCommentWebClockIn}
                                  disabled={!policyData?.allowWebClockIn}
                                  onChange={(isChecked) => handleChange('requireCommentWebClockIn',isChecked)}
                                  labelStyle={{fontSize: "1rem", lineHeight: 1.7, color: `${!policyData?.allowWebClockIn?`${tokens.textMuted}80`:tokens.textMuted}`}}
                              />
                          </Box>            
                      </Box>
            </Box>
        </Box>
        <Box sx={{ background: tokens.card, border: `1px solid ${tokens.border}`, borderRadius: `${radius.card}px`, padding: "1.5rem", marginBottom: "1.5rem" }}>
            <Headings title="Categories" description="Absenteeism and tardiness rules and their penalties." />
            <Box>
               <Box sx={{width:"48%"}}>
                  <SwitchToggle 
                      label="Enable Absenteeism"
                      labelStyle={{fontSize: '1rem',lineHeight: '1.5rem',color: tokens.text}}
                      checked={policyData?.enableAbsenteeism} 
                      onChange={(e)=>handleChange("enableAbsenteeism",e.target.checked)} 
                      disabled={!categoryEdit}
                  />
               </Box>
               {policyData?.enableAbsenteeism?(
                     <Box sx={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
                     <RadioButtonGroup
                         label="Automatically consider absent when there is no attendance login?"
                         labelStyle={{fontSize: "1rem",lineHeight: 1.7,color: tokens.textMuted, marginBottom: "4px"}}
                         horizontalLayout={true}
                         value={policyData?.autoDetectAbsenteeism} 
                         disabled={!categoryEdit}
                         onChange={(e) => handleChange('autoDetectAbsenteeism', e.target.value)}
                         options={[
                             { value: true, label: 'Yes' },
                             { value: false, label: 'No' }
                         ]}
                     />                  
                     <Box sx={{display:"flex", gap: "1rem", alignItems:"center"}}>
                         <TextBox>Minimum daily hours required to be considered present for a shift</TextBox>
                         <FormField
                             width="5rem"
                             type="text"
                             height="3rem"
                             disabled={!categoryEdit}
                             value={policyData.minDailyHours}
                             onChange={(e) => {handleChange('minDailyHours', e.target.value)}}
                         />             
                      </Box>
                      <Box sx={{display:"flex", gap: "1rem", alignItems:"center"}}>
                         <TextBox>Days of unreported leave will result in a warning before an employee faces penalties</TextBox>    
                         <Box sx={{display:"flex", alignItems:"center", gap: "0.75rem"}}>
                            <FormField
                                width="5rem"
                                type="text"
                                height="3rem"
                                disabled={!categoryEdit}
                                value={policyData.absenteeismThreshold}
                                onChange={(e) => {handleChange('absenteeismThreshold', e.target.value)}}
                            />
                            <Box sx={{fontSize:"1rem", lineHeight: 1.7, color: tokens.textMuted}}>
                                Day(s) in a  
                              </Box>
                              <FormField
                                  width="11.625rem"
                                  type="select"
                                  options={[{name:"Week",value:"weekly"},{name:"Month", value:"monthly"},{name:"Year", value:"yearly"}]}
                                  value={policyData?.absenteeismTimePeriod}
                                  onChange={(e) => {handleChange('absenteeismTimePeriod', e.target.value)}}
                              /> 
                          </Box>
                      </Box>
                     <CheckboxField
                             label={
                               <TextBox sx={{display:"flex", alignItems:"center", gap: "0.25rem"}}>
                                 Penalized adjoining holiday, if there are
                                 <FormField
                                       width="5rem"
                                       height="3rem"
                                       type="text"
                                       disabled={!categoryEdit}
                                       value={policyData.minAbsenceDurationForAdjoiningHolidayPenalty}
                                       onChange={(e) => {handleChange('minAbsenceDurationForAdjoiningHolidayPenalty', e.target.value)}}
                                 /> 
                                 or more day(s) with no attendance.
                               </TextBox>
                             }
                             disabled={!categoryEdit}
                             checked={policyData.penaliseAdjoiningHolidays}
                             onChange={(isChecked) => handleChange('penaliseAdjoiningHolidays',isChecked)}
                     />
                     <CheckboxField
                             label={
                               <TextBox sx={{display:"flex", alignItems:"center", gap: "0.25rem"}}>
                                 Penalized adjoining weekend off, if there are 
                                 <FormField
                                       width="5rem"
                                       height="3rem"
                                       type="text"
                                       disabled={!categoryEdit}
                                       value={policyData.minAbsenceDurationForAdjoiningWeekendPenalty}
                                       onChange={(e) => {handleChange('minAbsenceDurationForAdjoiningWeekendPenalty', e.target.value)}}
                                 /> 
                                 or more day(s) with no attendance.
                               </TextBox>
                             }
                             disabled={!categoryEdit}
                             checked={policyData.penaliseAdjoiningWeekends}
                             onChange={(isChecked) => handleChange('penaliseAdjoiningWeekends',isChecked)}
                     />    
                     <CheckboxField
                           label="Employees are penalized if the exceed allowed unreported absences in a week or month."
                           checked={policyData?.absenteeismPenalty !== "none"}
                           onChange={(isChecked) => {
                             handleChange('absenteeismPenalty', isChecked ? "deduct" : "none");
                           }}
                           labelStyle={{fontSize: "1rem", lineHeight: 1.7, color: tokens.textMuted}}
                           disabled={!categoryEdit}
                       />
                       {
                         policyData?.absenteeismPenalty !== "none"?(
                          <>
                             <RadioButtonGroup
                                 horizontalLayout={true}
                                 value={policyData?.absenteeismPenalty} 
                                 disabled={!categoryEdit}
                                 onChange={(e) => handleChange('absenteeismPenalty', e.target.value)}
                                 options={[
                                     { value: 'deduct', label: 'Loss of Pay' },
                                     { value: 'leave', label: 'Paid Leave' }
                                 ]}
                             />
                             {policyData?.absenteeismPenalty==="deduct"?
                              <Box sx={{width:"100%",display:"flex", alignItems:"center", gap: "0.25rem", color: tokens.textMuted}}>
                                 <FormField
                                       width="5rem"
                                       height="2rem"
                                       type="text"
                                       disabled={!categoryEdit}
                                       value={policyData?.noOfDaysOfPayLossForAbsenteeism}
                                       onChange={(e) => {handleChange('noOfDaysOfPayLossForAbsenteeism', e.target.value)}}
                                 /> 
                                 day(s) Pay loss (LOP) for each incident week.
                              </Box> :
                              (policyData?.absenteeismPenalty==="leave"?
                                <Box sx={{width:"100%",display:"flex", alignItems:"center", gap: "0.25rem", color: tokens.textMuted}}>
                                  <FormField
                                        width="5rem"
                                        height="2rem"
                                        type="text"
                                        disabled={!categoryEdit}
                                        value={policyData?.noOfPaidLeaveDeductForAbsenteeism}
                                        onChange={(e) => {handleChange('noOfPaidLeaveDeductForAbsenteeism', e.target.value)}}
                                  /> 
                                  day(s) Paid Leave.
                                </Box> 
                                :null) 
                             }
                          </>
                         ):null
                       }
                  </Box>
               ):null}
            </Box>
            <Box>
               <Box sx={{width:"48%"}}>
                  <SwitchToggle 
                      label="Enable Tardiness"
                      labelStyle={{fontSize: '1rem',lineHeight: '1.5rem',color: tokens.text}}
                      checked={policyData?.enableTardiness} 
                      onChange={(e)=>handleChange("enableTardiness",e.target.checked)} 
                      disabled={!categoryEdit}
                  />
               </Box>
               {policyData?.enableTardiness?(
                     <Box sx={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>                 
                        <Box sx={{width:"100%", display:"flex", flexWrap:"wrap", justifyContent: "space-between", alignItems:"center"}}>
                              <FormField
                                  label="Tardiness Type"
                                  type="select"
                                  options={[{name:"Late Login / Clock In", value:"late-login"},{name:"Low Punctuality", value:"low-punctuality"}]}
                                  value={policyData?.tardinessType}
                                  onChange={(e) => {handleChange('tardinessType', e.target.value)}}
                                  disabled={!categoryEdit}
                              />
                              <Box sx={{ width: "48%", marginBottom: '1.125rem'}}>
                                <TextBox sx={{marginBottom: '4px'}}>Scheduled Shift</TextBox>
                                <Autocomplete
                                  multiple
                                  options={shiftOptions}
                                  getOptionLabel={(option) => option?.name} 
                                  size="small"
                                  value={selectedShifts}
                                  onChange={handleShiftChange}
                                  disabled={!categoryEdit}
                                  sx={{
                                    '& .MuiInputBase-root': {
                                      borderRadius: '10px',
                                      fontSize: '1rem',
                                      lineHeight: '1.5rem',
                                      fontWeight:400,
                                      color: tokens.text,
                                      height: "3rem"
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: `1px solid `
                                    },
                                  }}
                                  renderInput={(params) => <TextField {...params} />}
                                />
                              </Box>
                              <Box sx={{width:"48%"}}>
                              <TextBox>Set Limit for {policyData?.tardinessType==="low-punctuality"?"minimum punctuality rate":"Grace Period"}</TextBox>
                              <Box sx={{width:"100%",display:"flex", alignItems:"center", gap: "0.75rem", color: tokens.textMuted}}>
                                  {policyData?.tardinessType==="low-punctuality"?
                                    (<>
                                      <FormField
                                          width="5rem"
                                          height="3.5rem"
                                          type="text"
                                          value={policyData?.minimumPunctuality}
                                          onChange={(e) => {handleChange('minimumPunctuality', e.target.value)}}
                                          disabled={!categoryEdit}
                                      /> /
                                      <FormField
                                            width="11.625rem"
                                            height="3.5rem"
                                            type="select"
                                            options={[{name:"Week",value:"weekly"},{name:"Month", value:"monthly"},{name:"Year", value:"yearly"}]}
                                            value={policyData?.tardinessType==="low-punctuality"?(policyData?.punctualityTimePeriod):(policyData?.tardinessTimePeriod)}
                                            onChange={(e) => {handleChange(
                                              policyData?.tardinessType==="low-punctuality"?"punctualityTimePeriod":"tardinessTimePeriod", e.target.value
                                            )}}
                                            disabled={!categoryEdit}
                                      /> 
                                    </>)
                                    :
                                    <MultiSectionClock 
                                          initialHours={Math.floor(policyData?.tardinessThreshold/60)||0}
                                          initialMinutes={Math.floor(policyData?.tardinessThreshold%60)||0}
                                          onChangeTime={(value) => handleChange('tardinessThreshold', value)}
                                          disabled={!categoryEdit}
                                      />
                                }
                              </Box> 
                              </Box>
                              <Box sx={{width:"48%"}}>
                                      <TextBox>How many times an employee is allowed to come in Late?</TextBox>
                                      <Box sx={{display:"flex", alignItems:"center", gap: "0.75rem", color: tokens.textMuted}}>
                                              <FormField
                                                    width="5rem"
                                                    height="3rem"
                                                    type="text"
                                                    value={policyData?.noOfPermissibleLateArrivals}
                                                    onChange={(e) => {handleChange('noOfPermissibleLateArrivals', e.target.value)}}
                                                    disabled={!categoryEdit}
                                              />
                                              {/* times in a
                                              <FormField
                                                    width="11.625rem"
                                                    height="3rem"
                                                    type="select"
                                                    options={["Month", "Week", "Year"]}
                                                    value={policyData?.lateAllowedFrequency}
                                                    // onChange={(e) => {handleChange('lateAllowedFrequency', e.target.value)}}
                                              />  */}
                                      </Box> 
                              </Box>
                              <CheckboxField
                                      label="Employees are penalized if the exceed allowed number of late arrival in a  week/ month. "
                                      checked={policyData?.tardinessPenalty !== "none"}
                                      onChange={(isChecked) => {
                                        handleChange('tardinessPenalty', isChecked ? "deduct" : "none");
                                      }}
                                      labelStyle={{fontSize: "1rem", lineHeight: 1.7, color: tokens.textMuted}}
                                      disabled={!categoryEdit}
                              />
                              {
                                policyData?.tardinessPenalty !== "none"?(
                                  <>
                                    <RadioButtonGroup
                                        horizontalLayout={true}
                                        value={policyData?.tardinessPenalty} 
                                        onChange={(e) => handleChange('tardinessPenalty', e.target.value)}
                                        options={[
                                            { value: 'deduct', label: 'Loss of Pay' },
                                            { value: 'leave', label: 'Paid Leave' }
                                        ]}
                                        disabled={!categoryEdit}
                                    />
                                    {policyData?.tardinessPenalty==="deduct"?
                                      <Box sx={{width:"100%",display:"flex", alignItems:"center", gap: "0.25rem", color: tokens.textMuted}}>
                                        <FormField
                                              width="5rem"
                                              height="2rem"
                                              type="text"
                                              value={policyData?.noOfDaysOfPayLossForTardiness}
                                              onChange={(e) => {handleChange('noOfDaysOfPayLossForTardiness', e.target.value)}}
                                              disabled={!categoryEdit}
                                        /> 
                                        day(s) Pay loss (LOP) for each incident week.
                                      </Box> : (
                                        policyData?.tardinessPenalty==="leave"?
                                          <Box sx={{width:"100%",display:"flex", alignItems:"center", gap: "0.25rem", color: tokens.textMuted}}>
                                            <FormField
                                                  width="5rem"
                                                  height="2rem"
                                                  type="text"
                                                  value={policyData?.noOfPaidLeaveDeductForTardiness}
                                                  onChange={(e) => {handleChange('noOfPaidLeaveDeductForTardiness', e.target.value)}}
                                                  disabled={!categoryEdit}
                                            /> 
                                            day(s) Paid Leave.
                                          </Box> 
                                        :null
                                      )
                                    }
                                  </>
                                ):null
                              }          
                        </Box>
                     </Box>
               ):null}
            </Box>
        </Box>
        <Box sx={{ background: tokens.card, border: `1px solid ${tokens.border}`, borderRadius: `${radius.card}px`, padding: "1.5rem", marginBottom: "1.5rem" }}>
            <Headings title="Assign Policy" description="Which departments or groups this policy applies to." />
            {/*
              The fallback tier. An employee whose group, grade and department
              match no policy resolves to none at all — and then cannot clock
              in, from the web or the phone, with "No attendance policy found".
              The server has always supported a default; nothing here could set
              one, so every unassigned employee hit that wall.
            */}
            {/*
              Whose rules these are. Rules differ by legal entity, and the
              server only applies a policy to employees of the entities it
              names — none named means the whole organisation.
            */}
            {entityOptions.length > 0 && (
              <Box sx={{ marginBottom: "1.25rem" }}>
                <TextBox sx={{ marginBottom: "4px" }}>Legal entities</TextBox>
                <Autocomplete
                  multiple
                  options={entityOptions}
                  getOptionLabel={(option) => option?.name || ""}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  size="small"
                  value={entityOptions.filter((o) => (policyData?.legalUnits || []).includes(String(o.value)))}
                  onChange={(e, picked) => handleChange("legalUnits", picked.map((o) => String(o.value)))}
                  disabled={!assignPolicyEdit}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={(policyData?.legalUnits || []).length ? "" : "All entities"}
                    />
                  )}
                />
              </Box>
            )}
            <Box sx={{ marginBottom: "1.25rem" }}>
              <SwitchToggle
                label="Default policy — applies to everyone in this policy's entities whom no other policy covers"
                labelStyle={{fontSize: '1rem', lineHeight: '1.5rem', color: tokens.text}}
                checked={Boolean(policyData?.isDefault)}
                onChange={(e) => handleChange("isDefault", e.target.checked)}
                disabled={!assignPolicyEdit}
              />
              <Box sx={{ fontSize: "0.8125rem", color: tokens.textMuted, marginTop: "0.25rem" }}>
                A department or group assigned below always takes precedence. A policy created with no entity selected applies across the whole organisation.
              </Box>
            </Box>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems:"center" }}>
                        <FormField
                            label="Sort By"
                            type="select"
                            options={["Departments","Groups"]}
                            value={sortBy}
                            disabled={!assignPolicyEdit}
                            onChange={(e)=>{setSortBy(e.target.value)}}
                        />
                        <FormField
                            label="Policy Bearers"
                            type="text"
                            value={formatPolicyBearer(selectedList)}
                            disabled={true}
                        />
            </Box>
            <Box sx={{marginBottom: "1rem"}}>
                <ErrorMsg>{error}</ErrorMsg>
            </Box>
            {(sortBy && assignPolicyEdit) && (
              <SortByTable
                sortBy={sortBy}
                data={data}
                selectedList={selectedList}
                setSelectedList={setSelectedList}  
              />
            )}   
        </Box>
        <Box sx={{ background: tokens.card, border: `1px solid ${tokens.border}`, borderRadius: `${radius.card}px`, padding: "1.5rem", marginBottom: "1.5rem" }}>
            <Headings title="Approval chain" description="Who reviews and approves attendance requests under this policy." />
            <Box>
            <Box>
            {   policyData?.approverIds?.length > 0 ? (
                <Box>
                 <Box sx={{fontSize: "1rem",lineHeight: 1.7, color: tokens.textMuted,marginBottom: "1rem"}}>
                    Approval Chain
                  </Box>
                 {
                  policyData?.approverIds?.map((item,index)=>(
                    <Box key={index} 
                         sx={{ width: "100%", 
                               display: "flex",  
                               marginBottom: "1rem", 
                               justifyContent:"space-between",
                               padding: "1.25rem 2rem",
                               borderRadius:"10px",
                               border:`1px solid `
                            }}
                    >
                          <FormField
                              placeholder="Employee Name"
                              type="select"
                              options={approverOptions}
                              value={item}
                              disabled={!approverEdit}
                              onChange={(e) => handleApproverChange(index, e.target.value)}
                          />
                          <TypeBtn type="remove" onClick={()=>handleRemoveApprover(index)} disabled={!approverEdit}>
                                  Remove 
                          </TypeBtn>
                    </Box>
                  ))
                  }
                </Box>
              ): (
                <Box sx={{fontSize:"1rem",lineHeight: 1.7, color: tokens.textMuted, marginBottom: "1rem"}}>
                        No approvers assigned yet
                </Box>
              )
            }
            <Box sx={{display:approverEdit?"flex":"none"}}>
                <TypeBtn onClick={handleAddApproval} type="add">
                    Add Approver
                </TypeBtn>
            </Box>
          </Box>
        </Box>
        </Box>
        <SettingsSaveBar
          dirtyCount={dirtyCount}
          onDiscard={discardChanges}
          onSave={handleSaveChanges}
          saving={apiCall}
        />
        <SaveDialog 
            open={isSaveOpen} 
            onClose={()=>setIsSaveOpen(false)} 
            redirectLink="/app/attendance-policy/listing"
        />
        </MainBox>
    </Box>
  ))
}

export default AttendancePolicyEdit
        